import styled from 'styled-components';
import { lighten } from 'polished';
//
import colors from 'theme/colors';

const { primary } = colors;

const colorMultiplier = 0.2;

export default styled.button({
  border: 'none',
  color: primary,
  fontWeight: 500,
  textDecoration: 'none',
  background: 'none',
  padding: 0,
  transition: 'color .2s ease-in',

  '&:hover': {
    cursor: 'pointer',
    color: lighten(colorMultiplier, primary),
  },
});
